export default __webpack_public_path__ + "static/media/interest-rates-icon.fbe2355f.svg";